import { HouseFilterState } from "@app/types/houseTypes";

export const initialState: HouseFilterState = {
	decorationFilter: { field: "decoration", selected: [], values: [] },
	priceFilter: { field: "price" },
	pricePerMeterFilter: { field: "squarePrice" },
	squareFilter: { field: "square" },
}